import type { FunctionComponent, SyntheticEvent } from 'react';
import { useCallback, useState } from 'react';
import classNames from 'classnames';

import { forTemplate } from '@trello/i18n';
import { Button } from '@trello/nachos/button';
import { PowerUpTestIds } from '@trello/test-ids';

import { useDeleteSharedPluginDataMutation } from './DeleteSharedPluginDataMutation.generated';

import styles from './DisablePluginSettings.less';

const format = forTemplate('directory_power_up_item');
interface Props {
  disablePlugin: (e: SyntheticEvent<EventTarget>) => void;
  boardId: string;
  pluginId: string;
  elem: SyntheticEvent<EventTarget>;
}

export const DisablePluginSettings: FunctionComponent<Props> = ({
  disablePlugin,
  boardId,
  pluginId,
  elem,
}) => {
  const [checked, setChecked] = useState(false);
  const [deleteSharedPluginData] = useDeleteSharedPluginDataMutation();

  const handleDisablePlugin = useCallback(async () => {
    disablePlugin(elem);
    if (checked) {
      await deleteSharedPluginData({
        variables: {
          boardId,
          pluginId,
        },
      });
    }
  }, [boardId, pluginId, deleteSharedPluginData, checked, elem, disablePlugin]);

  return (
    <>
      <div>
        <p>{format('delete-plugin-data-explain-message')}</p>
      </div>
      <div className={classNames('check-div', styles.checkbox)}>
        <input
          id="checkbox_id"
          type="checkbox"
          checked={checked}
          // eslint-disable-next-line react/jsx-no-bind
          onChange={() => setChecked(!checked)}
        />
        <label htmlFor="checkbox_id">{format('delete-plugin-data')}</label>
      </div>
      <Button
        appearance="danger"
        size="fullwidth"
        onClick={handleDisablePlugin}
        data-testid={PowerUpTestIds.DisablePowerUpButton}
      >
        {format('disable-plugin-button')}
      </Button>
    </>
  );
};
